export type AbortableDelayResult = 'completed' | 'aborted';

export const abortableDelay = (
  ms: number,
  signal?: AbortSignal,
): Promise<AbortableDelayResult> => {
  if (signal?.aborted) {
    return Promise.resolve('aborted');
  }

  return new Promise((resolve) => {
    let settled = false;

    const finish = (result: AbortableDelayResult) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      signal?.removeEventListener('abort', onAbort);
      resolve(result);
    };
    const onAbort = () => finish('aborted');
    const timer = setTimeout(() => finish('completed'), ms);

    signal?.addEventListener('abort', onAbort, { once: true });
  });
};
